(function () {
  

  class CardProduct extends HTMLElement {
  
    constructor() {
      // Always call super first in constructor
      super();

      const quickAtc = this.querySelector('.card_quick-atc');
      
      const quickAtcCloseButton = this.querySelector('.card_atc--close');
      quickAtc.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('cdebug quickatc', quickAtc);
        if(quickAtc.dataset.preorder) {
          document.location.href = quickAtc.dataset.url
        }
        quickAtc.closest('.card').querySelector('.card_atc--content').classList.add('active');

      })

      quickAtcCloseButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        quickAtcCloseButton.closest('.card').querySelector('.card_atc--content').classList.remove('active');

      })
    }
  }
  
  customElements.define("card-product", CardProduct);
})();